export default {"src":"/_next/static/media/renec.6c1aa497.svg","height":25,"width":24};